//
//
//
//

export default {
  mounted () {
    window.adroll_adv_id = '76KMFEGZSFES5HQM4JRUPZ'
    window.adroll_pix_id = '3NDWLR3YI5CVNO5EVVBK5Y'
    window.adroll_email = this.$store.getters['store/email']

    const scr = document.createElement('script')
    const host = ((document.location.protocol === 'https:') ? 'https://s.adroll.com' : 'http://a.adroll.com')
    scr.setAttribute('async', 'true')
    scr.type = 'text/javascript'
    scr.src = host + '/j/roundtrip.js';
    ((document.getElementsByTagName('head') || [null])[0] || document.getElementsByTagName('script')[0].parentNode).appendChild(scr)
  }
}
